import Vue from 'vue'
import autoTranslate from './autoTranslate'

const I18nPlugin = {
  install(VueCtor) {
    if (VueCtor.__pettyCashTranslateInstalled) {
      return
    }

    VueCtor.__pettyCashTranslateInstalled = true
    VueCtor.prototype.$translator = autoTranslate

    VueCtor.mixin({
      mounted() {
        if (this.$root !== this) {
          return
        }

        const syncProtectedTerms = () => {
          const state = this.$store ? this.$store.state : {}
          const terms = []

          const username = state && state.username ? String(state.username).trim() : ''
          const profileUsername = state && state.user_info && state.user_info.user && state.user_info.user.username
            ? String(state.user_info.user.username).trim()
            : ''

          if (username) {
            terms.push(username)
          }

          if (profileUsername) {
            terms.push(profileUsername)
          }

          if (profileUsername || username) {
            window.__PETTYCASH_USERNAME = profileUsername || username
          }

          autoTranslate.setProtectedTerms(terms)
        }

        const initialRoute = (this.$route && this.$route.fullPath) || ''
        autoTranslate.setCurrentPath(initialRoute)
        syncProtectedTerms()
        autoTranslate.init()

        this.__autoTranslateRouteUnwatch = this.$watch('$route.fullPath', newPath => {
          autoTranslate.setCurrentPath(newPath || '')
          syncProtectedTerms()
          autoTranslate.refreshIfEnabled('route')
          this.$nextTick(() => {
            autoTranslate.refreshIfEnabled('route')
          })
        })

        this.__autoTranslateUserUnwatch = this.$watch(
          () => this.$store && this.$store.state ? this.$store.state.username : '',
          () => {
            syncProtectedTerms()
            autoTranslate.refreshIfEnabled('dom')
          }
        )

        this.__autoTranslateProfileUserUnwatch = this.$watch(
          () => {
            if (!this.$store || !this.$store.state || !this.$store.state.user_info || !this.$store.state.user_info.user) {
              return ''
            }
            return this.$store.state.user_info.user.username || ''
          },
          () => {
            syncProtectedTerms()
            autoTranslate.refreshIfEnabled('dom')
          }
        )
      },
      beforeDestroy() {
        if (this.$root !== this) {
          return
        }

        if (typeof this.__autoTranslateRouteUnwatch === 'function') {
          this.__autoTranslateRouteUnwatch()
          this.__autoTranslateRouteUnwatch = null
        }

        if (typeof this.__autoTranslateUserUnwatch === 'function') {
          this.__autoTranslateUserUnwatch()
          this.__autoTranslateUserUnwatch = null
        }

        if (typeof this.__autoTranslateProfileUserUnwatch === 'function') {
          this.__autoTranslateProfileUserUnwatch()
          this.__autoTranslateProfileUserUnwatch = null
        }
      }
    })
  }
}

Vue.use(I18nPlugin)

export { autoTranslate }
export const translator = autoTranslate
export default I18nPlugin
